import React, { Suspense} from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './App.css';
import { routes } from './routes';
import Loader from './component/Loader';

function App() {

  
  return (
      <Router>
        <Suspense fallback={<Loader/>}>
          <Routes>
            {routes.map((route, index) => (
             
                <Route key={index+1} path={route.path} element={<route.element />} />
            ))}
          </Routes>
        </Suspense>
      </Router>
  );
}

export default App;